module.exports = __webpack_public_path__ + "public/img/money.e5ee056.png";